export default __webpack_public_path__ + "static/media/ms.36dfc347.svg";